import styled from 'styled-components';
import { FlexRow} from '@make-software/cspr-design';

export const NavigationMenuContainer = styled.nav(({ theme }) =>
  theme.withMedia({
    background: theme.styleguideColors.backgroundTertiary,
    padding: 0,
    width: '100%',
  })
);

export const VisibleMenuContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: theme.maxWidth,
    width: '100%',
    padding: ['19px 16px', '19px 32px', '0px 56px', '0px'],
    height: ['auto', 'auto', 'auto', '72px'],
    margin: [0],
  })
);